

























































































































































































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import GoodSelect from '@/components/goods-select/index.vue'
import PicModal from '@/components/upload/picModal.vue'
import GoodsApi from '@/api/goods/list'
@Component({
  components: {
    GoodSelect,
    PicModal
  }
})
export default class Products extends Vue {
  @Prop({
    type: Boolean,
    default: () => false
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'products',
        maxNumber: 6,
        cornerMark: null,
        // 0 选择分类 1 选择具体商品
        selectType: 0,
        // 商品分类Id 优先级高于 商品id数组
        categoryId: null,
        //商品id数组
        list: [],
        //商品展示数组
        products: [],
        title: '商品列表',
        // 0 1 2 三种样式
        styleType: 0,
        // 仅样式三生效
        rowNmuber: 3,
        titleConfig: {
          // text、img
          type: 'text',
          title: '商品列表',
          imgUrl: '',
          style: {
            backgroundColor: '#ffffff',
            color: '#000000'
          }
        }
      }
    }
  })
  ProductsConfig!: any

  showGoodsIndex = -1
  categoryList = []

  get showImg() {
    let img = ''
    switch (this.ProductsConfig.styleType) {
      case 0:
        img = require('@/assets/images/goodStyle-1.jpg')
        break
      case 1:
        img = require('@/assets/images/goodStyle-2.jpg')
        break
      case 2:
        img = require('@/assets/images/goodStyle-3.jpg')
        break
    }
    return img
  }

  /**
   * 将商品数组拆成每 rowNmuber 个一组
   */
  get goodList() {
    let result = []
    for (
      var i = 0;
      i < this.ProductsConfig.products.length;
      i += this.ProductsConfig.rowNmuber
    ) {
      result.push(
        this.ProductsConfig.products.slice(i, i + this.ProductsConfig.rowNmuber)
      )
    }

    return result
  }

  mounted() {
    this.getCategoriesAll()
  }

  /**
   * 获取商品分类
   */
  getCategoriesAll() {
    GoodsApi.getCategoriesAll().then(res => {
      if (res.data.items) {
        this.categoryList = res.data.items.map(child => {
          return {
            value: child.id,
            text: child.fullName
          }
        })
      }
    })
  }

  /**
   * 商品来源改变
   */
  selectTypeChange(e) {
    if (e == 1) {
      this.ProductsConfig.categoryId = null
    } else {
      this.ProductsConfig.list = []
      this.ProductsConfig.products = []
    }
  }

  /**
   * 选择商品信息
   */
  productsChange(e) {
    if (e) {
      e.forEach((item, index) => {
        if (
          this.ProductsConfig.list.indexOf(item.id) == -1 &&
          index < this.ProductsConfig.maxNumber &&
          this.ProductsConfig.list.length < this.ProductsConfig.maxNumber
        ) {
          this.ProductsConfig.list.push(item.id)
          this.ProductsConfig.products.push(item)
        }
      })
    }
  }

  /**
   * 鼠标移入/移出事件
   */
  onMouseFn(index?) {
    this.showGoodsIndex = index
  }

  /**
   * 删除所选商品
   */
  deleteFn(index) {
    this.ProductsConfig.list.splice(index, 1)
    this.ProductsConfig.products.splice(index, 1)
  }

  /**
   * 选择图片
   */
  picChange(e) {
    this.ProductsConfig.titleConfig.imgUrl = e[0].url
  }
}
